import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Dropdown, Spinner } from "react-bootstrap";
import { axiosInstance } from "../../helpers/axios/axios";
import {
  LogisticsProductsURL,
  exportStockReport,
} from "../../helpers/endpoints/api_endpoints";

const StockReportExport = ({ show, handleClose, clients, onExport }) => {
  const [selectedClient, setSelectedClient] = useState("");
  const [clientDocketNumber, setClientDocketNumber] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axiosInstance.get(LogisticsProductsURL);
      setProducts(response.data.results || []);
    } catch (error) {
      console.error("Error fetching products: ", error);
    }
  };

  const handleExportClick = async () => {
    setIsLoading(true);
    try {
      const filters = {
        client_id: selectedClient,
        client_docket_number: clientDocketNumber,
        product_id: selectedProduct,
      };
      await onExport(filters);
      handleClose();
    } catch (error) {
      console.error("Error exporting stock report: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetFilters = () => {
    setSelectedClient({ id: "", name: "Select Client" });
    setClientDocketNumber("");
    setSelectedProduct("");
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Export Stock Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Dropdown onSelect={(e) => setSelectedClient(e)} className="mb-2">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {clients?.results?.find(
              (client) => client.id === parseInt(selectedClient)
            )?.name || "Select Client"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {clients?.results?.map((client) => (
              <Dropdown.Item key={client.id} eventKey={client.id}>
                {client.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown onSelect={(e) => setSelectedProduct(e)} className="mt-3">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {products.find(
              (product) => product.id === parseInt(selectedProduct)
            )?.name || "Select Product"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {products.map((product) => (
              <Dropdown.Item key={product.id} eventKey={product.id}>
                {product.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <Form.Control
          className="mt-3"
          type="text"
          placeholder="Client Docket Number"
          value={clientDocketNumber}
          onChange={(e) => setClientDocketNumber(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
          Close
        </Button>
        <Button
          variant="secondary"
          onClick={handleResetFilters}
          disabled={isLoading}
        >
          Reset Filters
        </Button>
        <Button
          variant="primary"
          onClick={handleExportClick}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Exporting…
            </>
          ) : (
            "Export"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StockReportExport;
